import React from "react";
import ICMWrapper from "@/app/components/icm-wrapper";

type IconType = "megaphone" | "building" | "factory" | "chart";

interface InvestmentOpportunity {
    id: string;
    icon: IconType;
    title: string;
    description: string;
}

const investmentOpportunitiesData: InvestmentOpportunity[] = [
    {
        id: "pre-ipo",
        icon: "megaphone",
        title: "Pre-IPO Shares",
        description:
            "Shares of companies expected to go public in the future, purchased before their IPO.",
    },
    {
        id: "unlisted-public",
        icon: "building",
        title: "Shares of Unlisted Public Companies",
        description:
            " Public companies that are not listed on exchange but whose shares can be traded through platform.",
    },
    {
        id: "private-limited",
        icon: "factory",
        title: "Shares of Private Limited Companies*",
        description:
            "Shares of privately held companies, usually owned by founders, employees, early investors, or private investors.",
    },
    // {
    //     id: "delisted",
    //     icon: "chart",
    //     title: "Delisted Shares",
    //     description:
    //         "Shares of companies that were earlier listed on stock exchanges but later delisted voluntarily or due to regulations.",
    // },
];

const iconPaths: Record<IconType, React.ReactNode> = {
    megaphone: (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.33366 25.6666L10.2205 37.214C10.3017 37.5388 10.3423 37.7011 10.3903 37.8429C10.8595 39.228 12.1068 40.2019 13.5643 40.3211C13.7135 40.3333 13.8809 40.3333 14.2156 40.3333C14.6348 40.3333 14.8444 40.3333 15.021 40.3162C16.7662 40.1469 18.1473 38.7658 18.3165 37.0206C18.3337 36.844 18.3337 36.6344 18.3337 36.2152V10.0833M33.917 24.75C37.4608 24.75 40.3337 21.8771 40.3337 18.3333C40.3337 14.7895 37.4608 11.9166 33.917 11.9166M18.792 10.0833H11.917C7.36064 10.0833 3.66699 13.7769 3.66699 18.3333C3.667 22.8896 7.36064 26.5833 11.917 26.5833H18.792C22.0304 26.5833 25.9919 28.3193 29.0482 29.9853C30.8312 30.9573 31.7227 31.4432 32.3065 31.3717C32.848 31.3054 33.2574 31.0623 33.5747 30.6187C33.917 30.1402 33.917 29.183 33.917 27.2684V9.39815C33.917 7.48362 33.917 6.52635 33.5747 6.04792C33.2574 5.60428 32.848 5.36118 32.3065 5.29486C31.7227 5.22335 30.8312 5.70933 29.0482 6.68128C25.9919 8.34733 22.0304 10.0833 18.792 10.0833Z"
                stroke="#F15D2A"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    building: (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.8337 20.1667H32.6337C34.6872 20.1667 35.7139 20.1667 36.4983 20.5663C37.1882 20.9178 37.7491 21.4788 38.1007 22.1687C38.5003 22.953 38.5003 23.9798 38.5003 26.0333V38.5M23.8337 20.1667V11.3667C23.8337 9.31314 23.8337 8.28638 23.434 7.50203C23.0825 6.81211 22.5216 6.25118 21.8316 5.89964C21.0473 5.5 20.0205 5.5 17.967 5.5H11.367C9.31347 5.5 8.2867 5.5 7.50236 5.89964C6.81243 6.25118 6.2515 6.81211 5.89997 7.50203C5.50033 8.28638 5.50033 9.31314 5.50033 11.3667V38.5M23.8337 20.1667V38.5M38.5003 38.5H40.3337M38.5003 38.5H23.8337M23.8337 38.5H5.50033M5.50033 38.5H3.66699M11.917 12.8333H17.417M11.917 20.1667H17.417M11.917 27.5H17.417"
                stroke="#F15D2A"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    factory: (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.7503 12.8333H18.792M13.7503 20.1667H18.792M13.7503 27.5H18.792M25.2087 12.8333H30.2503M25.2087 20.1667H30.2503M25.2087 27.5H30.2503M36.667 38.5V11.3667C36.667 9.31314 36.667 8.28638 36.2673 7.50203C35.9158 6.81211 35.3549 6.25118 34.665 5.89964C33.8806 5.5 32.8539 5.5 30.8003 5.5H13.2003C11.1468 5.5 10.12 5.5 9.33569 5.89964C8.64577 6.25118 8.08484 6.81211 7.7333 7.50203C7.33366 8.28638 7.33366 9.31314 7.33366 11.3667V38.5M36.667 38.5H40.3337M36.667 38.5H7.33366M7.33366 38.5H3.66699"
                stroke="#F15D2A"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    chart: (
        <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M31.1667 16.5L21.2038 26.4629C20.8407 26.8259 20.6592 27.0074 20.4499 27.0754C20.2658 27.1353 20.0675 27.1353 19.8834 27.0754C19.6741 27.0074 19.4926 26.8259 19.1296 26.4629L15.7038 23.0371C15.3407 22.6741 15.1592 22.4926 14.9499 22.4246C14.7658 22.3647 14.5675 22.3647 14.3834 22.4246C14.1741 22.4926 13.9926 22.6741 13.6296 23.0371L5.5 31.1667M31.1667 23.8333V16.5H23.8333M14.3 38.5H29.7C32.7803 38.5 34.3204 38.5 35.4969 37.9005C36.5318 37.3732 37.3732 36.5318 37.9005 35.4969C38.5 34.3204 38.5 32.7803 38.5 29.7V14.3C38.5 11.2197 38.5 9.67957 37.9005 8.50305C37.3732 7.46816 36.5318 6.62677 35.4969 6.09946C34.3204 5.5 32.7803 5.5 29.7 5.5H14.3C11.2197 5.5 9.67957 5.5 8.50305 6.09946C7.46816 6.62677 6.62677 7.46816 6.09946 8.50305C5.5 9.67957 5.5 11.2197 5.5 14.3V29.7C5.5 32.7803 5.5 34.3204 6.09946 35.4969C6.62677 36.5318 7.46816 37.3732 8.50305 37.9005C9.67957 38.5 11.2197 38.5 14.3 38.5Z"
                stroke="#F15D2A"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
};

const OpportunityIcon: React.FC<{ type: IconType }> = ({ type }) => (
    <div className="flex h-[68px] w-[68px] shrink-0 items-center justify-center rounded-lg bg-[#FFF5F2] text-[#FF5722]">
        <div className="flex items-center justify-center">{iconPaths[type]}</div>
    </div>
);

const InvestmentOpportunities: React.FC = () => {
    return (
        <section
            className="w-full bg-white py-14 md:py-s18"
            aria-labelledby="investment-opportunities-heading"
        >
            <ICMWrapper>
                <div className="mx-auto flex w-full max-w-[1152px] flex-col items-center gap-10 md:gap-16">
                    <h2
                        id="investment-opportunities-heading"
                        className="max-w-[700px] text-center text-[32px] font-semibold leading-[120%] tracking-[-0.02em] text-neutral-900 md:text-6xl"
                    >
                        Explore investment opportunities that go beyond listed stocks.
                    </h2>

                    <ul className="grid w-full list-none grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
                        {investmentOpportunitiesData.map((item) => (
                            <li
                                key={item.id}
                                className="flex h-full flex-col gap-4 rounded-2xl border border-[#0E0F171A] bg-white p-6 shadow md:gap-5 md:p-8"
                            >
                                <OpportunityIcon type={item.icon} />
                                <div className="gap-0">
                                    <h3 className="mb-2 text-xl font-semibold leading-[130%] text-neutral-900">
                                        {item.title}
                                    </h3>
                                    <p className="text-base font-normal leading-[160%] text-[#494F6E]">
                                        {item.description}
                                    </p>
                                    {item.id === "private-limited" && (
                                        <p className="text-xs font-normal leading-normal text-[#494F6E] mt-2.5">
                                            *Mentioned for information purposes only. Private
                                            limited companies are not available on the platform.
                                        </p>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </ICMWrapper>
        </section>
    );
};

export default InvestmentOpportunities;
